<template>
    <div>
        <div v-if="result.waybillNo">
            <div class="mt-gap result">
                <div class="fl">
                    <p><span>运单号码</span> {{result.waybillNo}}</p>
                    <p><span>转单号码</span> {{result.transNo}}</p>
                    <p><span>当前状态</span> {{result.status}}</p>
                    <p><span>寄件日期</span> {{dateFormat(createTime)}}</p>
                    <p><span>订单状态</span> {{['待审核','待补录','待交寄','待出货','运输中','已完成','已取消','待修正','已签收'][status-1]}}</p>
                </div>
            </div>
            <div class="result-detail" v-if="result.datas&&result.datas.length>0">
                <div class="step-item"
                     v-for="(item,index) in result.datas"
                     :key="index"
                     :class="{'cur': index === 0,
                      'step1': index===result.datas.length-1,
                      'step3': item.isFinish == 1,
                      'step2': item.isFinish != 1 && index !== result.datas.length-1 && index===1&&hasFinish,
                      'step2Cur': item.isFinish != 1 && index !== result.datas.length-1 && index===0}">
                    <span class="icon"></span>
                    <p><span style="margin-right: 10px;color:#26a2ff;">【{{item.status}}】</span>{{item.location}}</p>
                    <p class="time">{{dateFormat(item.scanTime)}}</p>
                </div>
            </div>
            <div class="result-detail" v-else>
                <p style="text-align: center;color: #999;">没有数据</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: {},
                result: {},

                status: '',
                createTime: '',
            }
        },
        computed: {
            hasFinish() {
                return this.result.datas && this.result.datas[0].isFinish == 1;
            }
        },
        created() {
            this.search.transNo = this.$route.query.transNo;
            this.search.checkTime = this.$route.query.checkTime;
            this.status = this.$route.query.status;
            this.createTime = this.$route.query.createTime;
            this.search.companyNo = this.$util.get('companyNo');
            this.searchData();
        },
        methods: {
            dateFormat(dateTime) {
                var date = new Date(dateTime);
                var year = date.getFullYear();
                var month = date.getMonth()+1;
                if (month < 10) {
                    month = '0'+month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0'+day;
                }
                var hours = date.getHours();
                if (hours < 10) {
                    hours = '0'+hours;
                }
                var minutes = date.getMinutes();
                if (minutes < 10) {
                    minutes = '0' + minutes
                }
                var seconds = date.getSeconds();
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                return year+'-'+month+'-'+day + ' ' + hours+':'+minutes+':'+seconds;
            },
            searchData() {
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                this.http.send({command: "realtimetracking/orderTracking", params: this.search}).then((res) => {
                    this.result = res.data.body;
                    this.$indicator.close();
                }).catch(() => {
                    this.$indicator.close();
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .result {
        background-color: #fff;
        padding: 10px;
        overflow: hidden;
        .btn {
            color: #19a0ff;
            border: 1px solid #19a0ff;
            border-radius: 4px;
            padding: 4px 6px;
            margin-top: 6px;
        }
        p {
            color: #666666;
            span {
                color: #333;
                margin-right: 8px;
            }
        }
    }
    .result-detail {
        background-color: #fff;
        padding: 20px 10px;
        margin-top: 10px;
        color: #666;
        font-size: 14px;
        .step-item {
            padding: 0 0 10px 30px;
            position: relative;
            &:after {
                content: "";
                width: 1px;
                height: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 10px;
                background: #ddd;
            }
            &.step1:after {
                height: 0;
            }
            .time {
                margin-top: 4px;
                color: #666;
            }
            .icon {
                display: inline-block;
                width: 20px;
                height: 20px;
                position: absolute;
                left: 0;
                z-index: 3;
            }
            &.step1 .icon {
                background-image: url("../../assets/1.png");
                background-repeat: no-repeat;
                background-size: 20px auto;
                background-position: left top;
            }
            &.step2 .icon {
                background-image: url("../../assets/2.png");
                background-repeat: no-repeat;
                background-size: 20px auto;
                background-position: left top;
            }
            &.step2Cur .icon {
                background-image: url("../../assets/2h.png");
                background-repeat: no-repeat;
                background-size: 20px auto;
                background-position: left top;
            }
            &.step3 .icon {
                background-image: url("../../assets/3.png");
                background-repeat: no-repeat;
                background-size: 20px auto;
                background-position: left top;
            }
            &.cur {
                color: #333;
                &.step1 .icon {
                    background-image: url("../../assets/1h.png");
                }
                &.step3 .icon {
                    background-image: url("../../assets/3h.png");
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/order/order-desc.vue